// src/components/dev/utils/Footer/Footer.styled.ts
import styled from "styled-components";

export const StyledFooter = styled.footer`
  position: relative;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding: 15px;
  background-color: #fce248 !important; /* SunLight Civilization yellow */
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  font-size: 14px;

  /* Increase specificity for Ant Design footer */
  .ant-layout-footer & {
    background-color: #fce248;
  }

  @media (max-width: 768px) {
    gap: 10px;
    padding: 10px;
    font-size: 12px;
  }
`;

export const SitemapSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding-bottom: 10px; /* Add spacing between sitemap and main footer */
  border-bottom: 1px solid rgba(0, 0, 0, 0.1); /* Subtle separator */
`;

export const SitemapList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* Four columns */
  gap: 15px;
  justify-items: center;
  width: 100%;
  max-width: 800px; /* Constrain width for readability */

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); /* Two columns on mobile */
    gap: 10px;
  }
`;

export const SitemapLink = styled.a`
  color: #0427f4; /* Blue to match footer links */
  text-decoration: none;
  font-size: 12px; /* Smaller font for sitemap */
  transition: color 0.3s ease;

  &:hover {
    color: #ffaa00; /* Yellow on hover */
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #40c4ff;
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const MainFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: row; /* Keep in a single line */
    gap: 10px;
    flex-wrap: wrap; /* Allow wrapping if needed */
  }
`;